export interface DownloadOptions {
  url: string;
  extern?: boolean;
}
